import { c as _c } from "react/compiler-runtime";
import type { CountdownData } from "@/hooks/useMintCountdownState";
import { formatCountdownVerbose } from "@/utils/timeFormatters";
import { ArrowRightIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { memo, useEffect, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
interface NowMintingCountdownActiveProps {
  readonly countdown: CountdownData;
}
export default function NowMintingCountdownActive(t0) {
  const $ = _c(23);
  const {
    countdown
  } = t0;
  let t1;
  if ($[0] !== countdown.showAllowlistInfo) {
    t1 = countdown.showAllowlistInfo && <Tooltip id="allowlist-info" place="left" border="1px solid rgba(255, 255, 255, 0.15)" opacity={1} style={{
      backgroundColor: "#26272B",
      color: "white",
      padding: "10px 14px",
      maxWidth: "250px",
      fontSize: "14px",
      lineHeight: "1.4",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
      borderRadius: "6px"
    }} />;
    $[0] = countdown.showAllowlistInfo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== countdown.title) {
    t2 = <span className="tw-py-0.5 tw-text-xs tw-font-semibold tw-text-iron-300">{countdown.title}</span>;
    $[2] = countdown.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== countdown.showAllowlistInfo) {
    t3 = countdown.showAllowlistInfo && <InformationCircleIcon data-tooltip-id="allowlist-info" data-tooltip-content="The timer displays the current time remaining for a specific phase of the drop. Please refer to the distribution plan to check if you are in the allowlist." className="tw-size-5 tw-cursor-help tw-text-iron-400 hover:tw-text-iron-300" />;
    $[4] = countdown.showAllowlistInfo;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== countdown.isActive) {
    t4 = countdown.isActive ? <div className="tw-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-success/20 tw-bg-success/10 tw-px-2 tw-py-0.5"><span className="tw-relative tw-flex tw-h-2 tw-w-2"><span className="tw-absolute tw-inline-flex tw-h-full tw-w-full tw-animate-ping tw-rounded-full tw-bg-success/60" /><span className="tw-relative tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-success" /></span><span className="tw-text-[10px] tw-font-semibold tw-text-success/80">Live</span></div> : <div className="tw-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-amber-500/20 tw-bg-amber-500/10 tw-px-2 tw-py-0.5"><span className="tw-text-[10px] tw-font-semibold tw-text-amber-400">Upcoming</span></div>;
    $[6] = countdown.isActive;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-2">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== countdown.targetDate) {
    t7 = <div className="tw-flex tw-h-14 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-white/10 tw-bg-iron-950 tw-shadow-[inset_0_1px_2px_rgba(0,0,0,0.5)]"><div className="tw-text-xl tw-font-bold tw-tabular-nums tw-text-iron-50 md:tw-text-2xl"><LiveCountdown targetTimestampSeconds={countdown.targetDate} /></div></div>;
    $[14] = countdown.targetDate;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== countdown.showMintBtn) {
    t8 = countdown.showMintBtn && <Link href="/the-memes/mint" className="tw-mt-3 tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-gap-x-1.5 tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-bg-iron-200 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-950 tw-no-underline tw-ring-1 tw-ring-inset tw-ring-white tw-transition tw-duration-300 tw-ease-out focus:tw-z-10 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset desktop-hover:hover:tw-bg-iron-300 desktop-hover:hover:tw-text-iron-950 desktop-hover:hover:tw-ring-iron-300">Mint<ArrowRightIcon className="tw-size-4 tw-flex-shrink-0" strokeWidth={2} /></Link>;
    $[16] = countdown.showMintBtn;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="tw-relative tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white/5 tw-bg-iron-900/40 tw-p-3 tw-text-left md:tw-p-4">{t1}{t6}{t7}{t8}</div>;
    $[18] = t1;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
const LiveCountdown = memo(t0 => {
  const $ = _c(7);
  const {
    targetTimestampSeconds
  } = t0;
  let t1;
  if ($[0] !== targetTimestampSeconds) {
    t1 = () => formatCountdownVerbose(targetTimestampSeconds);
    $[0] = targetTimestampSeconds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [display, setDisplay] = useState(t1);
  const timerRef = useRef(null);
  let t2;
  let t3;
  if ($[2] !== targetTimestampSeconds) {
    t2 = () => {
      const targetMs = targetTimestampSeconds * 1000;
      const tick = () => {
        setDisplay(formatCountdownVerbose(targetTimestampSeconds));
        if (Date.now() >= targetMs) {
          return;
        }
        const now = Date.now();
        const msUntilNextSecond = 1000 - now % 1000;
        timerRef.current = setTimeout(tick, msUntilNextSecond);
      };
      tick();
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = null;
      };
    };
    t3 = [targetTimestampSeconds];
    $[2] = targetTimestampSeconds;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== display) {
    t4 = <span>{display}</span>;
    $[5] = display;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
});
LiveCountdown.displayName = "LiveCountdown";